<template>
  <el-main class="page-content-margin-unset">
    <!-- 编辑 -->
    <el-form
      :model="body"
      status-icon
      :rules="rules2"
      label-position="left"
      ref="ruleForm"
      :inline="true"
      label-width="100px"
      class="demo-ruleForm">
      <el-form-item
        label="物流单号"
        prop="logistics_num">
        <el-input
          v-model="body.logistics_num"
          clearable
          placeholder="请输入物流单号"/>
      </el-form-item>
      <el-form-item
        label="发货时间"
        prop="delivery_time">
        <el-date-picker
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="body.delivery_time"
          type="datetime"
          placeholder="选择日期时间"/>
      </el-form-item>
      <el-form-item
        label="出发地"
        prop="origin">
        <el-autocomplete
          popper-class="my-autocomplete"
          v-model="body.origin"
          :fetch-suggestions="searchDelivery"
          placeholder="请输入内容"
          @select="handleSelect">
          <i
            class="el-icon-edit el-input__icon"
            slot="suffix"/>
          <template slot-scope="{ item }">
            <div class="name">{{ item.title }}</div>
            <span class="addr">{{ item.address }}</span>
          </template>
        </el-autocomplete>
      </el-form-item>
      <el-form-item
        label="目的地"
        prop="destination">
        <el-autocomplete
          popper-class="my-autocomplete"
          v-model="body.destination"
          :fetch-suggestions="searchDelivery2"
          placeholder="请输入内容"
          @select="handleSelect2">
          <i
            class="el-icon-edit el-input__icon"
            slot="suffix"/>
          <template slot-scope="{ item }">
            <div class="name">{{ item.title }}</div>
            <span class="addr">{{ item.address }}</span>
          </template>
        </el-autocomplete>
      </el-form-item>
      <el-form-item
        label="线路类型"
        prop="path_type">
        <el-select
          v-model="body.path_type"
          placeholder="请选择">
          <el-option
            label="渝新欧"
            value="渝新欧"/>
          <el-option
            label="蓉新欧"
            value="蓉新欧"/>
          <el-option
            label="海运"
            value="海运"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="event().onSureClick('ruleForm')">保存</el-button>
        <el-button @click="event().onBackClick()">取 消</el-button>
      </el-form-item>
    </el-form>
    <div
      id="allmap"
      style="width:100%;height:580px"/>
  </el-main>
</template>

<script>
import map from './map'
import { addLogistics } from '../../api/logistics'

export default {
  mixins: [map],
  data() {
    return {
      imglist: [],
      imglist2: [],
      body: {
        path_type: '',
        logistics_num: '',
        delivery_time: '',
        origin: '',
        destination: '',
        origin_coordinate: {
          lat: 0,
          long: 0,
        },
        destination_coordinate: {
          lat: 0,
          long: 0,
        },
      },
      rules2: {
        logistics_num: [
          { required: true, message: '请输入物流单号', trigger: 'blur' },
        ],
        delivery_time: [
          { required: true, message: '请输入发货时间', trigger: 'blur' },
        ],
        origin: [
          { required: true, message: '请输入出发地', trigger: 'blur' },
        ],
        destination: [
          { required: true, message: '请输入目的地', trigger: 'blur' },
        ],
      },
    };
  },
  created() {
    this.handler().getDetail()
  },
  methods: {
    event() {
      return {
        onBackClick: () => {
          this.$router.go(-1)
        },
        onSureClick: (formName) => {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              // 调接口
              this.network().addLogistics()
            } else {
              console.log('error submit!!');
            }
          });
        },
      }
    },
    network() {
      return {
        addLogistics: async () => {
          const { status } = await addLogistics(this.body)
          if (status !== 200) return
          this.$notify({
            title: '新增物流单',
            message: '新增物流单成功',
            type: 'success',
          });
          this.$router.go(-1)
        },
      }
    },
    handler() {
      return {
        // 获取详情
        getDetail: () => {
          // 有uuid是编辑
          if (this.$route.query.uuid) {
            this.body = JSON.parse(sessionStorage.getItem('class'))
            this.imglist.push({
              response: {
                hash: this.body.banner_src,
              }, // response里面的hash是必须的
              url: this.imgDomain + this.body.banner_src, // url也是必须的
            })
            this.imglist2.push({
              response: {
                hash: this.body.img_src,
              }, // response里面的hash是必须的
              url: this.imgDomain + this.body.img_src, // url也是必须的
            })
          }
        },
      }
    },
  },
  components: {
  },
};
</script>

<style scoped lang="scss">

.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vuepage/logistics/add.vue